var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElderly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07812 3.04688C2.37699 3.04688 1.80859 2.47848 1.80859 1.77734V1.26953C1.80859 0.568395 2.37699 0 3.07812 0C3.77926 0 4.34766 0.568395 4.34766 1.26953V1.77734C4.34766 2.47848 3.77926 3.04688 3.07812 3.04688Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80078 11.7305C7.38008 11.7305 7.03906 12.0715 7.03906 12.4922V12.6191C7.03906 12.8295 7.20959 13 7.41992 13H8.18164C8.39198 13 8.5625 12.8295 8.5625 12.6191V12.4922C8.5625 12.0715 8.22148 11.7305 7.80078 11.7305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13892 8.75977L1.35212 12.64C1.36319 12.8419 1.53019 13 1.7324 13H3.48435C3.68656 13 3.85355 12.8419 3.86465 12.64L4.07783 8.75977H1.13892Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1816 11.0169V6.72845C8.1816 6.23265 7.92168 5.79669 7.53114 5.54883C7.4926 5.81807 7.38332 6.06464 7.2229 6.26946C7.34412 6.38512 7.41988 6.54805 7.41988 6.72845V11.0169C7.54165 10.9854 7.66927 10.9687 7.80074 10.9687C7.93221 10.9687 8.05983 10.9854 8.1816 11.0169Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02344 4.57026H4.75391V4.21479C4.75391 3.86633 4.62837 3.54733 4.4203 3.30005C4.06211 3.61616 3.59229 3.80854 3.07812 3.80854C2.45344 3.80854 1.89391 3.52488 1.52102 3.07983C0.873685 3.45242 0.4375 4.15061 0.4375 4.95112V7.61714C0.4375 7.82748 0.608023 7.998 0.818359 7.998H4.37305C4.58338 7.998 4.75391 7.82748 4.75391 7.61714V6.85542H3.86523C3.74537 6.85542 3.63248 6.79898 3.56055 6.70308L2.79883 5.68745C2.67261 5.51919 2.70674 5.28046 2.875 5.15425C3.04329 5.02803 3.28201 5.06218 3.4082 5.23042L4.05566 6.0937H6.02344C6.44413 6.0937 6.78516 5.75268 6.78516 5.33198C6.78516 4.91129 6.44413 4.57026 6.02344 4.57026Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElderly);
export default __webpack_public_path__ + "static/media/Elderly.4c406b2b3879ff2973481ec2705675b0.svg";
export { ForwardRef as ReactComponent };